import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useInsightsHeritageContent } from '../../../../hooks/useInsightsHeritageContent';
import './Heritage.css';

const Heritage = () => {
  const { content, isLoading } = useInsightsHeritageContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="insights-heritage">
      <div className="insights-heritage__inner">
        <Reveal className="insights-heritage__content">
          <h2 className="insights-heritage__title">{title}</h2>
          {text ? <p className="insights-heritage__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="insights-heritage__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Heritage;
